import React from 'react';
import {Router, Route, IndexRoute, browserHistory} from 'react-router'

import App from './App';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import PhotosPage from './PhotosPage';
import ThanksPage from './ThanksPage';
import TestimonialsPage from './TestimonialsPage';
import ContactPage from './ContactPage';


export default (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <Route path="/about" component={AboutPage} />
      <Route path="/contact" component={ContactPage} />
      <Route path="/testimonials" component={TestimonialsPage} />
      <Route path="/photos" component={PhotosPage} />
      <Route path="/thanks" component={ThanksPage} />
      <IndexRoute component={HomePage} />
    </Route>
  </Router>
);


/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/